import { getMoneyObj } from '../../reusable/MoneyJsHelpers.js';
import { REQUEST_TYPES_DB } from '../budgetRequestsHelpers.js';

export const createRequestStepZeroDisablingCondition = (requestType, request) => {
  if (request.description.trim().length === 0 || request.isOffset == null) {
    return true;
  }

  if (requestType === REQUEST_TYPES_DB.INCREASE_ITEM_COST) {
    return request.newTotalCost <= request.oldTotalCost;
  }

  if (requestType === REQUEST_TYPES_DB.DECREASE_ITEM_COST) {
    return request.newTotalCost >= request.oldTotalCost;
  }

  if (requestType === REQUEST_TYPES_DB.CREATE_NEW_ITEM_FROM_EXISTING) {
    return Number(request.newTotalCost || 0) === 0;
  }

  // == null also counts for undefined
  if (request.newTotalCost == null) {
    return true;
  }

  return false;
};

export const createRequestStepOneDisablingCondition = (requestType, request) => {
  if (requestType === REQUEST_TYPES_DB.DECREASE_ITEM_COST) {
    const currentProgramCosts = (request.allocations || []).map((allocation) =>
      Number(allocation.currentProgramCost),
    );

    const currentProgramCostsSumMoney = currentProgramCosts.reduce(
      (accumulator, cost) => {
        return accumulator.add(getMoneyObj(cost));
      },
      getMoneyObj(0),
    );
    const unallocatedSumMoney = getMoneyObj(request.oldTotalCost || 0).subtract(currentProgramCostsSumMoney);
    const proportionsArray = [ ...currentProgramCosts, unallocatedSumMoney.amount / 100 ].map(value => Math.abs(value));
    const proposedCosts = getMoneyObj(request.newTotalCost).allocate(proportionsArray);

    const maxDeallocatedSumMoney = proposedCosts.slice(0, proportionsArray.length - 1).reduce(
      (sum, money) => {
        return sum.add(money);
      }, 
      getMoneyObj(0)
    );

    const proposedProgramCostsSumMoney = (request.allocations || []).reduce(
      (sum, alloc) => {
        return sum.add(getMoneyObj(Number(Math.abs(alloc.requestedAmount))));
      },
      getMoneyObj(0)
    );

    return proposedProgramCostsSumMoney.greaterThan(maxDeallocatedSumMoney);
  } else {
    const allocatedSumMoney = (request.allocations || []).reduce(
      (total, allocation) => {
        return total.add(
          getMoneyObj(Math.abs(Number(allocation.requestedAmount)))
        );
      },
      getMoneyObj(0),
    );

    if (!allocatedSumMoney.equals(getMoneyObj(Math.abs(Number(request.requestedAmount))))) {
      return true;
    }

    return false;
  }
};

